/****************************************************
 * Module Name:  addReceiveModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, Button, Typography } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

function AddReceive({
  show,
  handleClose,
  handleValidation,
  handleSave,
  sourceData,
  loading,
}) {
  const [showError, setShowError] = useState(false);

  const saveHandler = () => {
    let data = {
      lotid: sourceData.id,
      userid: Constants.loggedInUser.id,
    };
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(data)) {
          //need to add labId here and in the parent component if need for validation
          handleSave(data);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(data);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            Receive Lot validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Receive Lot
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            Are you sure you want to <strong>Receive</strong> this Lot ?
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <LoadingButton
            variant="contained"
            onClick={saveHandler}
            type="Submit"
            loading={loading}
            loadingPosition="start"
            startIcon={<SaveIcon />}
            sx={{ mr: 3 }}
          >
            Yes
          </LoadingButton>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={loading}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default AddReceive;
